import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";

import { type Citation, citationPlace, getSegment, message } from "./queryClient";

/** Where a citation points: the segment and its exact source region. */
export function SegmentPage() {
  const { segmentId = "" } = useParams();
  const [citation, setCitation] = useState<Citation | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let current = true;
    getSegment(segmentId)
      .then((found) => {
        if (current) {
          setCitation(found);
          setError(null);
        }
      })
      .catch((caught: unknown) => {
        if (current) {
          setError(message(caught));
        }
      });
    return () => {
      current = false;
    };
  }, [segmentId]);

  if (error) {
    return <p role="alert">Could not load: {error}</p>;
  }
  if (!citation) {
    return <p>Loading segment.</p>;
  }
  return (
    <section aria-labelledby="segment-title">
      <p>
        <Link to="/knowledge-query">Back to knowledge query</Link>
      </p>
      <h1 id="segment-title">Segment {citation.segment_key}</h1>
      <dl aria-label="Segment">
        <dt>Source region</dt>
        <dd>{citationPlace(citation)}</dd>
        <dt>Authority</dt>
        <dd>{citation.source_authority}</dd>
        <dt>State</dt>
        <dd>{citation.lifecycle_state}</dd>
        <dt>Document revision</dt>
        <dd>{citation.document_revision ?? "Not stated"}</dd>
        <dt>Parsed document</dt>
        <dd>
          <code>{citation.parsed_document_id}</code>
        </dd>
        <dt>Region</dt>
        <dd>
          <code>{citation.region_id}</code>
        </dd>
      </dl>
    </section>
  );
}
